import { Step, StepLabel, Stepper, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import toast from "react-hot-toast";
import { Calendar } from "react-multi-date-picker";
import Select from "react-select";
import { Get, Set } from "../../../../Request";
import { ConvertDate, randomBetweenToNumber } from "../../Function";
import BoxShadow from "../BoxShadow";
import Cards from "../Cards";
import ClassTimeTable from "../ClassTimeTable";
import DropFile from "../DropFile";
import Region from "../Region";
import SelectUser from "../SelectUser";
import SelectSans from "../SelectSans";
import "./style.css";
import ConfirmTimes from "../ConfirmTimes";
import CheckEditor from "../CheckEditor";
import SeoKeywords from "../SeoKeywords";
const FormSteps = ({ elements, isApp }) => {
  const [form, setForm] = useState({
    time_table: { type: "deactive" },
    seo: { seoKeyword: [] },
  });
  const [step, setStep] = useState(elements.firstStep);
  const [keys, setKeys] = useState();
  const [labelStyle, setLabelStyle] = useState();
  const [loading, setLoading] = useState();
  const parseStep = step => {
    let number = step.split("_")[1];

    let result = {
      number,
      isFirst: number == 1,
      isLast: number == (keys && keys.length - 1),
    };
    return result;
  };

  useEffect(() => {
    setKeys(Object.keys(elements));
    setForm({ ...form, ...elements.initialeState });
  }, []);

  const checkAkeyExist = (data, key, nested) => {
    if (nested) {
      if (nested in data) {
        if (key in data[nested]) {
          return data[nested][key];
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      if ([key] in data) {
        return data[key];
      }
      return false;
    }
  };

  const validateSteps = step => {
    let result = true;
    let emptys = [];
    if (step) {
      elements[step]["form"].map(element => {
        if ("nested" in element && !element.noNeed) {
          if (element.nested in form) {
            if (!form[element.nested][element.key]) {
              result = false;
              emptys.push(element.name);
            }
          } else {
            result = false;
            emptys.push(element.name);
          }
        } else {
          if (!element.noNeed) {
            if (element.key in form) {
              if (!form[element.key]) {
                result = false;
                emptys.push(element.name);
              }
            } else {
              result = false;
              emptys.push(element.name);
            }
          }
        }
      });
    }

    return {
      status: result,
      message: emptys,
    };
  };

  const checkElementExist = (data, id) => {
    let result = false;
    data.map(element => {
      if (element == id) {
        result = true;
      }
    });
    return result;
  };

  const checkData = async (key, value, route) => {
    return await Get({
      url: route,
      data: { [key]: value },
    }).then(data => {
      if (data.check) {
        setLabelStyle({ ...labelStyle, [key]: false });
      } else {
        setLabelStyle({ ...labelStyle, [key]: true });
      }
    });
  };

  const submit = async (data = {}) => {
    setLoading(true);
    return await Set({
      url: elements.route,
      data: {
        ...form,
        ...data,
      },
    }).then(() => {
      setLoading(false);
    });
  };
  const checkValidate = async validate => {
    return await Set({
      url: validate.route,
      data: { ...form },
      neddata: true,
    }).then(response => {
      setForm({ ...form, checkValidate: response });
      return response;
    });
  };
  const checkSelect = (element, id) => {
    if (element.nested) {
      if (form[element.nested] && form[element.nested][element.key] == id) {
        return true;
      }
    } else {
      if (form[element.key] == id) {
        return true;
      }
    }
  };

  const parsData = (data, form) => {
    return (
      data &&
      [...data].map(({ id: value, name: label }) => ({
        value,
        label,
      }))
    );
  };

  const handlerMultiSelect = (arr, key, nested) => {
    arr = arr.map(({ value }) => value);
    if (nested) {
      setForm({ ...form, [nested]: { ...form[nested], [key]: arr } });
    } else {
      setForm({ ...form, [key]: arr });
    }
  };

  const chekElemet = element => {
    switch (element.type) {
      case "input":
        return (
          <div className={`my-2 ${element.col}`}>
            <TextField
              maxLength={element.check}
              fullWidth
              style={{
                borderColor: labelStyle && labelStyle[element.key] && "red",
              }}
              size="small"
              label={element.name}
              value={
                checkAkeyExist(element, "nested")
                  ? checkAkeyExist(form, element.key, element.nested)
                    ? checkAkeyExist(form, element.key, element.nested)
                    : ""
                  : checkAkeyExist(form, element.key)
                    ? checkAkeyExist(form, element.key, element.nested)
                    : ""
              }
              onChange={({ target: { value } }) => {
                if ("check" in element) {
                  if (value.length == element.check) {
                    checkData(element.key, value, element.method.route);
                  }

                  if ("nested" in element) {
                    setForm({
                      ...form,
                      [element.nested]: {
                        ...form[element.nested],
                        [element.key]: value,
                      },
                    });
                  } else {
                    setForm({ ...form, [element.key]: value });
                  }
                } else {
                  if ("nested" in element) {
                    setForm({
                      ...form,
                      [element.nested]: {
                        ...form[element.nested],
                        [element.key]: value,
                      },
                    });
                  } else {
                    setForm({ ...form, [element.key]: value });
                  }
                }
              }}
            />
          </div>
        );
      case "select":
        return (
          <div className={`my-2 ${element.col}`}>
            <label htmlFor="">{element.name}</label>
            <select
              onChange={({ target: { value } }) => {
                if ("nested" in element) {
                  setForm({
                    ...form,
                    [element.nested]: {
                      ...form[element.nested],
                      [element.key]: value,
                    },
                  });
                } else {
                  setForm({ ...form, [element.key]: value });
                }
              }}
              name=""
              id=""
              className="form-control input-form"
            // defaultValue={checkSelect(element, option.id)}
            >
              <option value="">انتخاب کنید</option>
              {element.options.map((option, key) => {
                return (
                  <option value={option.id} key={key}>
                    {option.name}
                  </option>
                );
              })}
            </select>
          </div>
        );
      case "textArea":
        if (element.key == "seoKeyword") {
          return (
            <SeoKeywords
              options={{
                key: "seoKeyword",
                nested: "seo",
              }}
              element={element}
              form={form}
              setForm={setForm}
            />
          );
        }
        return (
          <div className={`my-2 ${element.col}`}>
            <label htmlFor="">{element.name}</label>
            <textarea
              value={
                checkAkeyExist(element, "nested")
                  ? checkAkeyExist(form, element.key, element.nested)
                    ? checkAkeyExist(form, element.key, element.nested)
                    : ""
                  : checkAkeyExist(form, element.key)
                    ? checkAkeyExist(form, element.key, element.nested)
                    : ""
              }
              className="form-control input-form"
              onChange={({ target: { value } }) => {
                if ("nested" in element) {
                  setForm({
                    ...form,
                    [element.nested]: {
                      ...form[element.nested],
                      [element.key]: value,
                    },
                  });
                } else {
                  setForm({ ...form, [element.key]: value });
                }
              }}
            />
          </div>
        );
      case "file":
        return (
          <div className={`my-2 ${element.col}`}>
            <label1>{element.name}</label1>
            <DropFile
              // value={form[element.key]}
              accept={element.accept}
              set={e => {
                setForm({ ...form, [element.key]: e });
              }}
            />
            {element.alt && (
              <SeoKeywords
                form={form}
                setForm={setForm}
                options={{
                  title: "متن جایگزین تصاویر",
                  key: "images_alt",
                  nested: false,
                }}
              />
            )}
          </div>
        );
      case "editor":
        return (
          <CheckEditor
            element={{ label: element.name }}
            handleChange={data => {
              element.nested
                ? setForm({
                  ...form,
                  [element.nested]: {
                    ...form[element.nested],
                    [element.key]: data,
                  },
                })
                : setForm({ ...form, [element.key]: data });
            }}
            data={
              element.nested
                ? form[element.nested] && form[element.nested][element.key]
                : form[element.key]
            }
          />
        );
      case "selectTable":
        return (
          <div className={`my-2 ${element.col}`}>
            <label htmlFor="">{element.name}</label>
            <Select
              placeholder={"انتخاب کنید"}
              isMulti={true}
              options={parsData(element.options, {
                id: "value",
                name: "label",
              })}
              onChange={e => {
                handlerMultiSelect(e, element.key, element.nested);
              }}
            />
          </div>
        );
      case "region":
        return (
          <div className={`my-2 ${element.col}`}>
            <Region data={form} set={setForm} />
          </div>
        );
      case "card":
        return (
          <div className={`my-2 ${element.col}`}>
            <Cards form={form} set={setForm} element={element} />
          </div>
        );
      case "timeTable":
        return (
          <div className={`my-2 ${element.col}`}>
            <ClassTimeTable form={form} set={setForm} element={element} />
          </div>
        );
      case "date":
        return (
          <div className={`my-2 ${element.col}`}>
            <label
              // className={`${labelStyle ? "bg-success" : "bg-danger"}`}
              htmlFor=""
            >
              {element.name}
            </label>
            <Calendar
              // range={true}
              onChange={data => {
                if ("nested" in element) {
                  setForm({
                    ...form,
                    [element.nested]: {
                      ...form[element.nested],
                      [element.key]: ConvertDate(
                        `${data.year}/${data.month.number}/${data.day}`
                      ),
                    },
                  });
                } else {
                  setForm({
                    ...form,
                    [element.key]: ConvertDate(
                      `${data.year}/${data.month.number}/${data.day}`
                    ),
                  });
                }
              }}
              calendar={persian}
              // multiple={true}
              locale={persian_fa}
            />
          </div>
        );
      case "selectUser":
        return (
          <div className="my-2 col-12">
            <SelectUser form={form} setform={setForm} />
          </div>
        );
      case "selectSans":
        return (
          <div className="my-2 col-12">
            <SelectSans contractPage={true} isApp={isApp} form={form} setform={setForm} />
          </div>
        );
      case "confirm":
        return <ConfirmTimes isApp={isApp} form={form} setform={setForm} />;
      case "customComponent":
        return element.render(form, setForm);
      default:
        break;
    }
  };
  return (
    <>
      {!isApp &&
        <BoxShadow style={{ padding: "10px", }} >
          <Stepper activeStep={+parseStep(step)["number"] - 1}>
            {elements.steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};

              return (
                <Step key={index} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </BoxShadow>
      }


      {isApp &&
        elements.steps.map((item, index) => (
          parseStep(step)["number"] == index + 1 &&
          <p className="shadow-sm text-center my-2 py-1 border rounded nfs-14" key={index}>{item}</p>
        ))
      }

      <BoxShadow
        style={{
          padding: "10px",
          marginTop: "20px",
        }}
        className={isApp && "shadow-none mt-2 p-2"}
      >
        <div className="d-flex flex-column justify-content-between">
          <div className="row" style={{ minHeight: !isApp && "400px" }}>
            {elements[step]["form"].map(element => chekElemet(element))}
          </div>
          <div className="row justify-content-between mt-5">
            <div className="col">
              <div className="row">
                <div className={isApp ? "col-12" : "col-3"}>
                  {!parseStep(step)["isFirst"] && (
                    <button
                      onClick={() => {
                        setStep(`step_${+parseStep(step)["number"] - 1}`);

                        setLabelStyle();
                      }}
                      className={"btn btn-primary " + (isApp && "w-100")}
                    >
                      مرحله قبل
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="col">
              <div className="row justify-content-end">
                <div className={"d-flex justify-content-end " + (isApp ? "col-12" : "col-8")}>
                  {elements.lastStep == step ? (
                    <button
                      disabled={loading}
                      onClick={() => {
                        if (elements.filterData) {
                          submit(elements.filterData(form));
                        } else {
                          submit();
                        }
                      }}
                      className={"btn btn-primary " + (isApp && "w-100")}
                    >
                      {loading ? "در حال پردازش" : elements.lastBtn}
                    </button>
                  ) : (
                    <button
                      onClick={async () => {
                        if (validateSteps(step)["status"]) {
                          if (elements[step].method) {
                            elements[step].method();
                            setStep(`step_${+parseStep(step)["number"] + 1}`);
                          } else if (elements[step].validate) {
                            await checkValidate(elements[step].validate).then(
                              res => {
                                if (elements[step].validate.key) {
                                  if (
                                    res[elements[step].validate.key] == "true"
                                  ) {
                                    setStep(
                                      `step_${+parseStep(step)["number"] + 1}`
                                    );
                                  } else {
                                    return;
                                  }
                                }
                                if (res) {
                                  setStep(
                                    `step_${+parseStep(step)["number"] + 1}`
                                  );
                                }
                              }
                            );
                          } else {
                            setStep(`step_${+parseStep(step)["number"] + 1}`);
                          }
                        } else {
                          toast.error(
                            `${validateSteps(step)["message"].map(
                              filed => filed
                            )} وارد نشده است`
                          );
                        }

                        setLabelStyle();
                      }}
                      className={"btn btn-primary " + (isApp && "w-100")}
                    >
                      مرحله بعد
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </BoxShadow>
    </>
  );
};

export default FormSteps;
